var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWithPanels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.1755352 7.3871665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h595.276v841.89H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h596v842H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h595.276v841.89H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -59.02491 38.12773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.1548 88.4986c0-.475-.385-.86-.86-.86h-17.19c-.475 0-.86.385-.86.86v9.025c0 .516.231 1.004.63 1.331l7.736 6.329c.634.518 1.544.518 2.178 0l7.736-6.329c.399-.327.63-.815.63-1.331z",
    fill: "none",
    stroke: "#918f90",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.35278 0 0 -.35278 -59.02491 38.12773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.9807 107.5786l-8.166-6.661",
    fill: "none",
    stroke: "#918f90",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.35278 0 0 -.35278 -59.02491 38.12773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.9975 91.9367c0-.237-.192-.43-.43-.43h-7.736c-.237 0-.429.193-.429.43v3.438c0 .238.192.43.429.43h7.736c.238 0 .43-.192.43-.43z",
    fill: "none",
    stroke: "#918f90",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWithPanels);
export default __webpack_public_path__ + "static/media/home-with-panels.45c11690.svg";
export { ForwardRef as ReactComponent };